type ValidPositionKey = 'left' | 'center' | 'right' | 'top' | 'bottom'

export const positionMapping = {
  left: {
    flex: 'justify-start',
    object: 'object-left',
  },
  center: {
    flex: 'justify-center',
    object: 'object-center',
  },
  right: {
    flex: 'justify-end',
    object: 'object-right',
  },
  top: {
    flex: 'items-start',
    object: 'object-top',
  },
  bottom: {
    flex: 'items-end',
    object: 'object-bottom',
  },
} as const

export type PositionMapping = typeof positionMapping
export type ValidPositionType = keyof PositionMapping[ValidPositionKey]
export type ValidMappedPosition = PositionMapping[ValidPositionKey][ValidPositionType]

export const getPositionValue = (
  position: ValidPositionKey | null | undefined,
  type: ValidPositionType,
): ValidMappedPosition | '' => {
  if (!position || !type) {
    return ''
  }
  return positionMapping[position][type]
}
